import { render, staticRenderFns } from "./AccordionSection.vue?vue&type=template&id=73512d72&scoped=true&"
import script from "./AccordionSection.vue?vue&type=script&lang=js&"
export * from "./AccordionSection.vue?vue&type=script&lang=js&"
import style0 from "./AccordionSection.vue?vue&type=style&index=0&id=73512d72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73512d72",
  null
  
)

export default component.exports